<template>
  <div>
    <el-form-item label="Environment">
      <el-select v-model="form.env" @change="change">
        <el-option value="local" label="Local" />
        <el-option value="testing" label="Testing" />
        <el-option value="production" label="Production" />
      </el-select>
    </el-form-item>

    <el-form-item label="Debug">
      <el-select v-model="form.debug" @change="change">
        <el-option value="false" label="No" />
        <el-option value="true" label="Yes" />
      </el-select>
    </el-form-item>

    <el-form-item label="Composer">
      <el-select v-model="form.composer" @change="change">
        <el-option value="auto" label="Auto" />
        <el-option value="no" label="Disabled" />
      </el-select>
    </el-form-item>

    <el-form-item label="Database">
      <el-select v-model="form.db" @change="change">
        <el-option value="mysql:5.7" label="MySQL 5.7 (embedded)" />
      </el-select>

      <el-button icon="mdi mdi-open-in-new" @click.prevent="dbadmin">phpMyAdmin</el-button>
    </el-form-item>
  </div>
</template>

<script>
import config from '../../../mixins/config'
export default {
  mixins: [config],
  methods: {
    dbadmin () {
      window.open(this.applicationUrl(this.form) + '/runstack-dbadmin/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-button {
    margin-top: 5px;
    margin-bottom: 5px;
  }
</style>
